export type TCandleProps = {
  testID?: string
  className?: string
  enabled?: boolean
  onFinish: VoidFunction
}
